import type { WorkspacePresence } from "@/features/presence/types";

// A member of a team. Mirrors the backend TeamMemberDto, which extends UserDto.
export type TeamMember = {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
  phone: string | null;
  imageUrl: string | null;
  externalId: string | null;
  title: string | null;
  timezone: string | null;
  language: string | null;
  presence?: WorkspacePresence | null;
};

export const TEAM_ASSIGNMENT_STRATEGY = {
  ROUND_ROBIN: "round_robin",
  LEAST_ASSIGNED: "least_assigned",
  ONLINE: "online",
} as const;

export type TeamAssignmentStrategy =
  (typeof TEAM_ASSIGNMENT_STRATEGY)[keyof typeof TEAM_ASSIGNMENT_STRATEGY];

export const TEAM_ASSIGNMENT_STRATEGY_OPTIONS: Array<{
  value: TeamAssignmentStrategy;
  label: string;
  description: string;
}> = [
  {
    value: TEAM_ASSIGNMENT_STRATEGY.ONLINE,
    label: "Who's online",
    description: "Online member with the fewest open conversations",
  },
  {
    value: TEAM_ASSIGNMENT_STRATEGY.LEAST_ASSIGNED,
    label: "Least assigned",
    description: "Member with the fewest open conversations",
  },
  {
    value: TEAM_ASSIGNMENT_STRATEGY.ROUND_ROBIN,
    label: "Round robin",
    description: "Rotate through members in order",
  },
];

export type Team = {
  id: string;
  name: string;
  description: string | null;
  color: string | null;
  assignmentStrategy: TeamAssignmentStrategy;
  members: TeamMember[];
  memberCount: number;
};
